'use client';

import AppImage from '@/components/ui/AppImage';

import useScrollReveal from '@/hooks/useScrollReveal';

export default function PortfolioHero() {
  const { ref: heroRef, isVisible: heroVisible } = useScrollReveal<HTMLElement>();

  return (
    <section ref={heroRef} className="relative py-20 sm:py-24 md:py-32 lg:py-40 overflow-hidden bg-brand-plum">
      {/* Full-width Hero Image */}
      <div className="absolute inset-0 z-0">
        <AppImage
          src="https://img.rocket.new/generatedImages/rocket_gen_img_108d7d806-1778619701983.png"
          alt="Documentary-style photo of creative team reviewing project work in raw industrial workspace with authentic energy"
          width={1920}
          height={1080}
          className="w-full h-full object-cover" />
        
        {/* Dark overlay with edge */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 text-center z-10">
        <div className={`transition-all duration-1000 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="inline-block px-3 py-1.5 sm:px-5 sm:py-2 bg-brand-orange text-white font-body text-[10px] sm:text-xs font-bold mb-4 sm:mb-6 uppercase tracking-wider shadow-lg transition-all duration-300 hover:bg-brand-teal">
            REAL PROBLEMS • STRUCTURAL SOLUTIONS
          </div>
          <h1 className="font-headline text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl mb-4 sm:mb-6 text-white font-bold leading-[1.1] drop-shadow-2xl">
            Selected Work
          </h1>
          <p className="font-body text-base sm:text-lg md:text-xl text-white leading-relaxed max-w-3xl mx-auto drop-shadow-lg px-4">
            We don't chase vanity metrics or viral moments. Every project here represents a structural change—a founder who can now compete with established companies, a nonprofit that can finally scale, a business that runs efficiently instead of chaotically. Real outcomes, not case study theater.
          </p>
        </div>
      </div>
    </section>);

}